import { isLoading, Loading } from "../../../Loading";
import { AppAgenciesState } from "../../../system/AppState/AppAgenciesState";

interface Props {
  appAgenciesState: AppAgenciesState | Loading;
}

export default function useMedflytAgencyId(props: Props) {
  if (isLoading(props.appAgenciesState)) {
    return null;
  }

  const medflytAgencyId = [...props.appAgenciesState.agencies.values()].find(
    (x) => x.agency.isMedflytAgency
  );

  if (medflytAgencyId === undefined) {
    return null;
  }

  return medflytAgencyId.id;
}
